











































































import 'bootstrap';
import bootbox from 'bootbox';
import {Component, Vue, Prop} from 'vue-property-decorator';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import UserProfile from '@/classes/UserProfile';
import { sprintf } from 'sprintf-js';
import _ from 'underscore';
import binaryDownload from '@/services/BinaryDownloader';

@Component
export default class CenterList extends Vue {
    public currPage: number = 1;
    public perPage: number = 10;

    get currentPage(): number {
        if (this.currPage > this.pages) {
            return this.pages;
        } else {
            return this.currPage;
        }
    }

    set currentPage(num: number) {
        this.currPage = num;
    }

    get pages(): number {
        return Math.ceil((this.filteredJobCorpCenters.length ? this.filteredJobCorpCenters.length : 1) / this.perPage);
    }


    // Filters
    public filterFieldCoordinator: UserProfile | null | undefined = null;
    public filterCenterName: string | null = null;
    public filterCity: string | null = null;
    public filterState: string | null = null;
    public filterStatus: boolean | null = null;

    public clearFilters(): void {
        this.filterFieldCoordinator = null;
        this.filterCenterName = null;
        this.filterCity = null;
        this.filterState = null;
        this.filterStatus = null;
    }

    get jobCorpCenters(): JobCorpsCenter[] {
        const centers: JobCorpsCenter[] | undefined = this.$store.getters.getJobCorpsCenters;
        if (centers !== undefined) {
            return centers;
        } else {
            return [];
        }
    }

    get filteredJobCorpCenters(): JobCorpsCenter[] {
        let filtered: JobCorpsCenter[] = this.jobCorpCenters;
        if (this.filterCenterName !== null && this.filterCenterName.length > 0) {
            filtered = filtered.filter((center: JobCorpsCenter) => {
                if (center.name !== undefined && center.name !== null && this.filterCenterName !== null) {
                    return center.name.toLowerCase().includes(this.filterCenterName.toLowerCase());
                } else {
                    return false;
                }
            });
        }
        if (this.filterCity !== null && this.filterCity.length > 0) {
            filtered = filtered.filter((center: JobCorpsCenter) => {
                if (center.addressCity !== undefined && center.addressCity !== null && this.filterCity !== null) {
                    return center.addressCity.toLowerCase().includes(this.filterCity.toLowerCase());
                } else {
                    return false;
                }
            });
        }
        if (this.filterState !== null && this.filterState.length > 0) {
            filtered = filtered.filter((center: JobCorpsCenter) => {
                if (center.addressState !== undefined && center.addressState !== null && this.filterState !== null) {
                    return center.addressState.toLowerCase().includes(this.filterState.toLowerCase());
                } else {
                    return false;
                }
            });
        }
        if (this.filterFieldCoordinator !== null && this.filterFieldCoordinator !== undefined
            && this.filterFieldCoordinator.jobCorpsCenterIds !== undefined) {
            const userCenters: number[] = this.filterFieldCoordinator.jobCorpsCenterIds;
            filtered = filtered.filter((center: JobCorpsCenter) => {
                if (center.id !== undefined) {
                    return userCenters.includes(center.id);
                } else {
                    return false;
                }
            });
        }
        if (this.filterStatus !== null) {
            filtered = filtered.filter((center: JobCorpsCenter) => {
                return center.active === this.filterStatus;
            });
        }
        return filtered;
    }

    get fieldCoordinators(): UserProfile[] {
        const fcs: UserProfile[] | undefined = this.$store.getters['users/getFieldCoordinators']();
        if (fcs !== undefined) {
            return fcs;
        } else {
            return [];
        }
    }

    get fields() {
        return [{
            key: 'name',
            label: 'Job Corps Center'
        }, {
            key: 'fieldCoordinator',
            label: 'Field Coordinator(s)',
            sortable: true
        }, {
            key: 'addressCity',
            label: 'City',
            sortable: true
        }, {
            key: 'addressState',
            label: 'State',
            sortable: true
        }, {
            key: 'active',
            label: 'Active',
            sortable: true
        }, {
            key: 'edit',
            label: ''
        }];
    }

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
            return user.getFullName();
        } else {
            return '';
        }
    }

    private formatFieldCoordinators(ids: number[] | undefined): string {

        return undefined === ids || 0 === ids.length ? '' : _.map(ids, (id) => {
            return sprintf('<span><a href="/#/administration/user/profile/%d">%s</a></span>',
                id,
                this.getUserProfileName(id)
            );
        }).join(', ');
    }

    private async exportCenters() {
        try {
            await binaryDownload('GET', '/api/v1/centers/export');
        } catch (err) {
            bootbox.alert(err);
        }
    }
}
